import { StepConnector, StepLabel, Stepper, styled } from '@mui/material';
import { theme } from 'v3/styles/global-styles';

export const StepperStyled = styled(Stepper)(() => ({
  '& .Mui-disabled': {
    svg: { color: theme.palette.secondary.light },
  },

  '& .Mui-completed': {
    svg: { color: theme.palette.details.main },
  },

  '& .Mui-active': {
    svg: { color: theme.palette.details.main },
  },

  '& .Mui-error': {
    svg: { color: theme.palette.error.main },
  },

  text: {
    fill: theme.palette.primary.dark,
  },

  '& .MuiStep-root': {
    padding: 0,
  },

  [theme.breakpoints.up('sm')]: {
    gap: '1.5rem',
  },
}));

export const StepLabelStyled = styled(StepLabel)(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  gap: '0.5rem',

  '& .MuiStepLabel-iconContainer': {
    paddingRight: 0,
  },
}));

export const StepConnectorStyled = styled(StepConnector)(() => ({
  span: {
    display: 'none',
  },
}));
